import {
  type DefaultItemProps,
  Item as DSItem,
  ItemAvatar as DSItemAvatar,
  ItemAvatarBadge as DSItemAvatarBadge,
  ItemAction,
  ItemContent,
  ItemDescription,
  type ItemPropsBase,
  type ItemRenderLinkComponent,
  ItemSide,
  ItemTitle,
  type Url,
} from "@opensea/ui-kit"
import { AvatarImage, type AvatarProps } from "../Avatar"
import { Link, type LinkProps } from "../Link"

type LinkItemProps = ItemPropsBase & {
  href: Url
} & LinkProps

export type ItemProps = DefaultItemProps | LinkItemProps

export function Item(props: ItemProps) {
  return <DSItem renderLink={Link as ItemRenderLinkComponent} {...props} />
}

export function ItemAvatar(props: AvatarProps) {
  return <DSItemAvatar {...props} renderImage={AvatarImage} />
}

export const ItemAvatarBadge = DSItemAvatarBadge
export { ItemContent, ItemTitle, ItemDescription, ItemSide, ItemAction }
